import { useState } from 'react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmPasswordReset } from 'firebase/auth';
import { auth } from 'firebaseConfig'; // Certifique-se de que o caminho esteja correto
import Card from '@mui/material/Card';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import BasicLayout from 'layouts/authentication/components/BasicLayout';
import bgImage from 'assets/images/azulpetroleo.png';
import logoBranca from 'assets/images/logos/logobranca.png';

function ConfirmResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  // Extrai o código de redefinição de senha da URL
  const queryParams = new URLSearchParams(location.search);
  const oobCode = queryParams.get('oobCode');

  const handleOpenModal = (message) => {
    setModalMessage(message);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSubmit = async () => {
    if (newPassword.length < 6) {
      handleOpenModal('A senha deve ter pelo menos 6 caracteres.');
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      handleOpenModal('Senha redefinida com sucesso!');
      setTimeout(() => {
        navigate('/authentication/sign-in');
      }, 3000);
    } catch (error) {
      handleOpenModal('Erro ao redefinir a senha. O link pode estar expirado ou inválido.');
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Card
          sx={{
            background: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(10px)',
            borderRadius: '15px',
            padding: '2rem',
            maxWidth: '400px',
            width: '100%',
            color: 'white',
          }}
        >
          <MDBox textAlign="center" mb={2}>
            <img src={logoBranca} alt="Logomarca" width="150" />
          </MDBox>
          <MDTypography variant="h5" fontWeight="medium" mb={2} textAlign="center" color="white">
            Redefinir sua Senha
          </MDTypography>
          <MDTypography variant="body2" color="white" mb={2} textAlign="center">
            Insira sua nova senha abaixo
          </MDTypography>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Nova Senha"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                fullWidth
                sx={{ input: { color: 'white' } }}
              />
            </MDBox>
            <MDBox mt={2} mb={1}>
              <MDButton variant="contained" color="info" fullWidth onClick={handleSubmit}>
                Salvar
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      {/* Modal de Alerta */}
      <Modal open={showModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 300,
            bgcolor: 'background.paper',
            borderRadius: '10px',
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
          }}
        >
          <MDTypography variant="h6">{modalMessage}</MDTypography>
          <MDButton variant="contained" color="info" sx={{ mt: 2 }} onClick={handleCloseModal}>
            Fechar
          </MDButton>
        </Box>
      </Modal>
    </BasicLayout>
  );
}

export default ConfirmResetPassword;
